import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Menu, X, ChevronDown, MapPin, Clock, Phone, Wrench, Shield, Zap, Star, ArrowRight, ChevronRight } from "lucide-react";
import { SiFacebook, SiLine, SiTiktok } from "react-icons/si";

/* @section: images */
const IMAGES = {
  logo: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/ENZO%202026%20Logo%20RGB%20Trans-01_50a56c58d8b844dbbd7924c8c679b113.png",
  logo2026: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/ENZO%202026%20Logo%20RGB%20Trans-01_50a56c58d8b844dbbd7924c8c679b113.png",
  ddSPlus: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDS%2B_6114cacf205e46548d6798aff2d5bf8f.png",
  ddRS: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDRS_3764d684d48849bbbe1c437be33fbe35.png",
  ddRPlus: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDR%2B_526dca0ab8c54567ad32473cb1fbb2df.png",
  ddA: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DDA_29f6f9b809624fc48f7e855ed955c08e.png",
  dd5: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DD5_2494fe12b27146799a4b017e53051eaf.png",
  dd7: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DD7_9d81c7dde06e4a59b65b51ed26d8317d.png",
  hero: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/album_export_3950f1b3_1781606653255_024c45cc0e144dd78fa7422f491f3b8b.jpg",
  workshop: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/album_export_34119430_1781606653294_068fcb5998b44217a8ec1705c5341594.jpg",
  coilover: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/album_export_29f36fa_1781606653237_ad4d95122d5a446a97222a797a877c86.jpg",
  hyperWax: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/C253F4C0-85D5-4891-B740-76B9CD58B16C_L0_001_1772362668.806705_o_IMG_2795_91ed290a4a264e4e92215b618b03b894.png",
  whiteEV: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/album_export_38092fa6_1781606653243_a44c836c7253407bbbfeebb4d120432e.jpg",
  blackEV: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/album_export_16d69800_1781606653264_c41f4014f707471dae2662550d09b568.jpg",
  workshopAction: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/DC05A2AD-857F-489C-ACDB-9ECA54674D30_L0_001_178152_94e47346adb440a6a19c34c31ee4d2b8.jpg",
  sign3D: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/364BDD1F-42FB-47D1-B52A-27DC27528EEA_L0_001_1772340029.319336_o_IMG-052_cfd3d753b48b4530869625b716953103.jpeg",
  sticker: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/album_export_220f95b9_1781606653249_8aba59ea95d74b53914034f0811d48c7.jpg",
  lineQR: "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-16/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/18F37054-9C02-4B0E-AB15-15692C229BB6_L0_001_178152_67a6f78c693848f0b4a84ba29fde0a17.png",
};

/* @section: navbar */
function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handler = () => setScrolled(typeof window !== "undefined" && window.scrollY > 40);
    if (typeof window !== "undefined") {
      window.addEventListener("scroll", handler);
      return () => window.removeEventListener("scroll", handler);
    }
  }, []);

  const links = [
    { label: "หน้าแรก", href: "#hero" },
    { label: "เกี่ยวกับเรา", href: "#about" },
    { label: "บริการ", href: "#services" },
    { label: "แกลเลอรี", href: "#gallery" },
    { label: "ติดต่อเรา", href: "#contact" },
  ];

  const pageLinks = [
    { label: "รีวิว", href: "/#/reviews" },
    { label: "เกี่ยวกับเรา", href: "/#/about" },
  ];

  const handleNav = (href: string) => {
    setIsOpen(false);
    const el = typeof document !== "undefined" ? document.querySelector(href) : null;
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const navLinkStyle: React.CSSProperties = {
    background: "none", border: "none", cursor: "pointer",
    color: "#e5e5e5", fontSize: "14px", fontWeight: 600,
    letterSpacing: "0.05em", transition: "color 0.2s",
    fontFamily: "Rajdhani, sans-serif", textTransform: "uppercase",
  };
  const pageNavStyle: React.CSSProperties = {
    color: "#e5e5e5", fontSize: "13px", fontWeight: 600,
    letterSpacing: "0.05em", transition: "color 0.2s",
    fontFamily: "Rajdhani, sans-serif", textTransform: "uppercase",
    textDecoration: "none",
  };

  return (
    <>
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        transition: "background 0.3s, box-shadow 0.3s",
        background: scrolled ? "rgba(13,13,13,0.97)" : "rgba(13,13,13,0.6)",
        boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.5)" : "none",
        borderBottom: scrolled ? "1px solid rgba(232,33,42,0.3)" : "1px solid transparent",
      }}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <button onClick={() => handleNav("#hero")} style={{ display: "flex", alignItems: "center", gap: "10px", background: "none", border: "none", cursor: "pointer" }}>
            <img src={IMAGES.logo} alt="ENZO Performante Store" style={{ height: "40px", width: "auto", objectFit: "contain" }} />
          </button>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-6">
            {/* หน้าแรก — position 1 */}
            <button onClick={() => handleNav("#hero")} style={navLinkStyle}
              onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.color = "#E8212A"; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.color = "#e5e5e5"; }}>
              หน้าแรก
            </button>
            {/* สินค้า — position 2 */}
            <a href="/#/products" style={pageNavStyle}
              onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => { (e.currentTarget as HTMLAnchorElement).style.color = "#E8212A"; }}
              onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => { (e.currentTarget as HTMLAnchorElement).style.color = "#e5e5e5"; }}>
              สินค้า
            </a>
            {/* Section links (skip หน้าแรก — already rendered above) */}
            {links.slice(1).map((l) => (
              <button key={l.href} onClick={() => handleNav(l.href)} style={navLinkStyle}
                onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.color = "#E8212A"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.color = "#e5e5e5"; }}>
                {l.label}
              </button>
            ))}
            <div style={{ width: "1px", height: "16px", background: "rgba(255,255,255,0.15)" }} />
            {pageLinks.map((l) => (
              <a key={l.href} href={l.href} style={pageNavStyle}
                onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => { (e.currentTarget as HTMLAnchorElement).style.color = "#E8212A"; }}
                onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => { (e.currentTarget as HTMLAnchorElement).style.color = "#e5e5e5"; }}>
                {l.label}
              </a>
            ))}
          </div>

          {/* CTA + Mobile Menu */}
          <div className="flex items-center gap-3">
            <a href="https://www.facebook.com/EnzoPerformanteStore/" target="_blank" rel="noopener noreferrer"
              style={{ display: "flex", alignItems: "center", gap: "6px", padding: "8px 16px", background: "#1877F2", color: "#fff", borderRadius: "2px", fontSize: "13px", fontWeight: 700, textDecoration: "none", fontFamily: "Rajdhani, sans-serif", letterSpacing: "0.05em", textTransform: "uppercase", transition: "background 0.2s" }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = "#b51820"; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = "#E8212A"; }}>
              <SiFacebook size={14} />
              <span className="hidden sm:inline">ติดต่อเรา</span>
            </a>
            <button className="md:hidden" onClick={() => setIsOpen(!isOpen)}
              style={{ background: "none", border: "none", cursor: "pointer", color: "#fff", padding: "4px" }}>
              {isOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          style={{ background: "rgba(13,13,13,0.98)", borderTop: "1px solid rgba(232,33,42,0.3)", padding: "16px" }}
        >
          {links.slice(0, 1).map((l) => (
            <button key={l.href} onClick={() => handleNav(l.href)}
              style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", cursor: "pointer", color: "#e5e5e5", fontSize: "16px", fontWeight: 600, padding: "12px 8px", fontFamily: "Rajdhani, sans-serif", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              {l.label}
            </button>
          ))}
          <a href="/#/products" onClick={() => setIsOpen(false)}
            style={{ display: "block", color: "#E8212A", fontSize: "16px", fontWeight: 700, padding: "12px 8px", fontFamily: "Rajdhani, sans-serif", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid rgba(255,255,255,0.05)", textDecoration: "none" }}>
            สินค้า
          </a>
          {links.slice(1).map((l) => (
            <button key={l.href} onClick={() => handleNav(l.href)}
              style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", cursor: "pointer", color: "#e5e5e5", fontSize: "16px", fontWeight: 600, padding: "12px 8px", fontFamily: "Rajdhani, sans-serif", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
              {l.label}
            </button>
          ))}
          {pageLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setIsOpen(false)}
              style={{
                display: "block",
                color: "#e5e5e5",
                fontSize: "16px",
                fontWeight: 600,
                padding: "12px 8px",
                fontFamily: "Rajdhani, sans-serif",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
                borderBottom: "1px solid rgba(255,255,255,0.05)",
                textDecoration: "none",
              }}
            >
              {l.label}
            </a>
          ))}
        </motion.div>
      )}
    </nav>

    {/* Floating LINE Button */}
    <a
      href="https://lin.ee/usuFQKq"
      target="_blank"
      rel="noopener noreferrer"
      title="ติดต่อผ่าน LINE"
      style={{
        position: "fixed",
        right: "20px",
        bottom: "80px",
        zIndex: 999,
        width: "56px",
        height: "56px",
        background: "#06C755",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 20px rgba(6,199,85,0.5)",
        textDecoration: "none",
      }}
    >
      <SiLine size={28} color="#fff" />
    </a>
    </>
  );
}

/* @section: hero */
function Hero() {
  return (
    <section
      id="hero"
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        background: "#0D0D0D",
      }}
    >
      {/* Background Image */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${IMAGES.hero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.45)",
        }}
      />
      {/* Gradient Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background: "linear-gradient(135deg, rgba(13,13,13,0.9) 0%, rgba(13,13,13,0.3) 60%, rgba(232,33,42,0.08) 100%)",
        }}
      />
      {/* Red left accent */}
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "4px",
          background: "#E8212A",
        }}
      />

      {/* Content */}
      <div className="container mx-auto px-4 text-center" style={{ position: "relative", zIndex: 2 }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "32px" }}>
            <img src={IMAGES.logo} alt="ENZO Performante Store" style={{ height: "90px", objectFit: "contain" }} />
          </div>

          <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "14px", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, marginBottom: "16px" }}>
            DWD Thailand x ENZO Performante Store
          </p>

          <h1
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(40px, 8vw, 88px)",
              fontWeight: 700,
              color: "#FFFFFF",
              lineHeight: 1.05,
              letterSpacing: "-0.02em",
              marginBottom: "24px",
              textShadow: "0 4px 40px rgba(0,0,0,0.6)",
            }}
          >
            THE ULTIMATE
            <br />
            <span style={{ color: "#E8212A" }}>PERFORMANCE</span>
            <br />
            DESTINATION
          </h1>

          <p
            style={{
              fontFamily: "Sarabun, sans-serif",
              fontSize: "clamp(15px, 2.5vw, 20px)",
              color: "rgba(255,255,255,0.75)",
              maxWidth: "560px",
              margin: "0 auto 40px",
              lineHeight: 1.7,
            }}
          >
            ในฐานะตัวแทนจำหน่ายอย่างเป็นทางการของ DWD Coilover เราส่งมอบโซลูชันช่วงล่างที่แม่นยำ พร้อมบริการปรับจูนที่พิถีพิถัน เพื่อให้รถของคุณตอบสนองได้ดั่งใจในทุกเส้นทาง
          </p>

          <div style={{ display: "flex", gap: "16px", justifyContent: "center", flexWrap: "wrap" }}>
            <button
              onClick={() => {
                const el = typeof document !== "undefined" ? document.getElementById("services") : null;
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "14px 32px",
                background: "#E8212A",
                color: "#fff",
                border: "none",
                borderRadius: "2px",
                fontSize: "15px",
                fontWeight: 700,
                cursor: "pointer",
                fontFamily: "Rajdhani, sans-serif",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                transition: "background 0.2s, transform 0.15s",
              }}
              onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = "#b51820"; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = "#E8212A"; }}
            >
              ดูบริการของเรา <ChevronRight size={16} />
            </button>
            <a
              href="https://www.facebook.com/EnzoPerformanteStore/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "14px 32px",
                background: "transparent",
                color: "#fff",
                border: "2px solid rgba(255,255,255,0.4)",
                borderRadius: "2px",
                fontSize: "15px",
                fontWeight: 700,
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                transition: "border-color 0.2s, color 0.2s",
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLAnchorElement;
                el.style.borderColor = "#E8212A";
                el.style.color = "#E8212A";
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLAnchorElement;
                el.style.borderColor = "rgba(255,255,255,0.4)";
                el.style.color = "#fff";
              }}
            >
              <SiFacebook size={16} /> Facebook
            </a>
          </div>
        </motion.div>

        {/* Scroll indicator */}
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          style={{ position: "absolute", bottom: "-60px", left: "50%", transform: "translateX(-50%)", color: "rgba(255,255,255,0.4)" }}
        >
          <ChevronDown size={28} />
        </motion.div>
      </div>

      {/* Stats bar */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          background: "rgba(13,13,13,0.85)",
          borderTop: "1px solid rgba(232,33,42,0.4)",
          padding: "20px",
          zIndex: 3,
        }}
      >
        <div className="container mx-auto px-4">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
              gap: "16px",
              textAlign: "center",
            }}
          >
            {[
              { num: "EV", label: "EV Car Specialist", sub: "อัพเกรดรถไฟฟ้า" },
              { num: "DWD", label: "Official Distributor", sub: "Official Distributor in Thailand" },
              { num: "9:00–18:00", label: "เวลาทำการ", sub: "จันทร์ – อาทิตย์" },
              { num: "ENZO", label: "Car Detailing", sub: "Premium Products" },
            ].map((s) => (
              <div key={s.label}>
                <div style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "22px", fontWeight: 700, color: "#E8212A" }}>{s.num}</div>
                <div style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "12px", fontWeight: 700, color: "#fff", letterSpacing: "0.1em", textTransform: "uppercase" }}>{s.label}</div>
                <div style={{ fontFamily: "Sarabun, sans-serif", fontSize: "11px", color: "rgba(255,255,255,0.5)" }}>{s.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

/* @section: about */
function About() {
  return (
    <section id="about" style={{ background: "#0D0D0D", padding: "100px 0" }}>
      <div className="container mx-auto px-4">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "60px",
            alignItems: "center",
          }}
        >
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            style={{ position: "relative" }}
          >
            <div style={{ position: "relative", borderRadius: "4px", overflow: "hidden" }}>
              <img
                src={IMAGES.workshop}
                alt="ENZO Workshop"
                style={{ width: "100%", height: "420px", objectFit: "cover", display: "block" }}
              />
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(232,33,42,0.15) 0%, transparent 70%)" }} />
            </div>
            {/* Decorative accent */}
            <div
              style={{
                position: "absolute",
                bottom: "-16px",
                right: "-16px",
                width: "120px",
                height: "120px",
                border: "3px solid #E8212A",
                borderRadius: "2px",
                zIndex: 0,
                opacity: 0.6,
              }}
            />
            {/* Badge */}
            <div
              style={{
                position: "absolute",
                top: "20px",
                left: "20px",
                background: "#E8212A",
                color: "#fff",
                padding: "8px 16px",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "13px",
                letterSpacing: "0.1em",
                textTransform: "uppercase",
              }}
            >
              Professional Workshop
            </div>
          </motion.div>

          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.1 }}
          >
            <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "13px", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, marginBottom: "16px" }}>
              เกี่ยวกับเรา
            </p>
            <h2
              style={{
                fontFamily: "Rajdhani, sans-serif",
                fontSize: "clamp(32px, 5vw, 52px)",
                fontWeight: 700,
                color: "#FFFFFF",
                lineHeight: 1.1,
                marginBottom: "24px",
              }}
            >
              DWD THAILAND
              <br />
              <span style={{ color: "#E8212A" }}>× ENZO</span>
              <br />
              PERFORMANTE STORE
            </h2>
            <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "16px", color: "rgba(255,255,255,0.7)", lineHeight: 1.8, marginBottom: "20px" }}>
              เราคือจุดหมายปลายทางชั้นนำสำหรับผู้หลงใหลในยนตรกรรมสมรรถนะสูง (Performance Automotive) โดยมุ่งเน้นการส่งมอบประสบการณ์การปรับแต่งช่วงล่างที่แม่นยำและตอบโจทย์ทุกการใช้งาน ตั้งแต่การขับขี่บนท้องถนนทั่วไปจนถึงการแข่งขันในสนามระดับมืออาชีพ ด้วยมาตรฐานวิศวกรรมจาก DWD และทีมช่างเทคนิคผู้เชี่ยวชาญประสบการณ์ตรงจากสนามแข่งที่พร้อมดูแลรถของคุณด้วยความละเอียดพิถีพิถันในทุกขั้นตอน
            </p>


            {/* Feature list */}
            <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "36px" }}>
              {[
                { title: "Official Partnership", text: "ในฐานะตัวแทนจำหน่ายอย่างเป็นทางการของโช้คอัพ DWD ในประเทศไทย เรานำเสนอผลิตภัณฑ์คุณภาพสูงที่ผ่านการรับรองมาตรฐานสากล" },
                { title: "Expert Engineering", text: "ทีมงานของเรามีความเชี่ยวชาญด้านการปรับจูนช่วงล่าง (High Performance Tuning) เพื่อดึงสมรรถนะสูงสุดของรถยนต์ออกมาตามความต้องการของลูกค้าแต่ละท่าน" },
                { title: "Premium Solutions", text: "คัดสรรผลิตภัณฑ์ดูแลรักษารถยนต์ระดับพรีเมี่ยม เพื่อการปกป้องและยกระดับสภาพรถของคุณให้สมบูรณ์แบบในระยะยาว" },
              ].map((f) => (
                <div key={f.title} style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
                  <div style={{ width: "6px", height: "6px", background: "#E8212A", borderRadius: "50%", flexShrink: 0, marginTop: "9px" }} />
                  <div>
                    <p style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "14px", fontWeight: 700, color: "#E8212A", letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: "2px" }}>{f.title}</p>
                    <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "14px", color: "rgba(255,255,255,0.75)", lineHeight: 1.6, margin: 0 }}>{f.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="https://www.facebook.com/EnzoPerformanteStore/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "12px 28px",
                background: "#E8212A",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "14px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "2px",
              }}
            >
              สัมผัสผลงานติดตั้งของเรา <ArrowRight size={16} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}

/* @section: services */
function Services() {
  const services = [
    {
      icon: <Zap size={32} />,
      title: "Suspension Tuning",
      titleTh: "ปรับแต่งช่วงล่าง",
      desc: "ติดตั้งและปรับแต่งระบบ Coilover DWD DD-Series ประสิทธิภาพสูง พร้อมปรับค่า damping ให้เหมาะกับการใช้งานของคุณ",
      img: IMAGES.workshopAction,
      tags: ["DWD Coilover", "DD-Series", "Coilover Thailand"],
    },
    {
      icon: <Wrench size={32} />,
      title: "Performance Tuning",
      titleTh: "ปรับแต่งสมรรถนะ",
      desc: "บริการปรับแต่งรถยนต์เพื่อสมรรถนะสูงสุด ด้วยประสบการณ์จากช่างผู้เชี่ยวชาญ รองรับทั้งรถยนต์ ICE และ EV",
      img: "https://static-us-img.skywork.ai/prod/nexus/1781619876/cropped_image_1_1781619876715520058.jpg",
      tags: ["MOTVE Brake", "6-Piston", "High Performance"],
    },
    {
      icon: <Shield size={32} />,
      title: "Car Care & Detailing",
      titleTh: "ดูแลรักษาสีรถ",
      desc: "ผลิตภัณฑ์ดูแลรักษาสีรถคุณภาพสูง Hyper Wax Liquid Ceramic Coating สูตร SiO2 ปกป้องสีรถจากมลภาวะ ให้ความเงางาม",
      img: IMAGES.hyperWax,
      tags: ["Hyper Wax", "Ceramic SiO2", "Car Detailing"],
    },
  ];

  return (
    <section id="services" style={{ background: "#111", padding: "100px 0" }}>
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: "center", marginBottom: "64px" }}
        >
          <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "13px", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, marginBottom: "16px" }}>
            สิ่งที่เราทำได้
          </p>
          <h2
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(32px, 5vw, 56px)",
              fontWeight: 700,
              color: "#FFFFFF",
              lineHeight: 1.1,
            }}
          >
            SERVICES & <span style={{ color: "#E8212A" }}>EXPERTISE</span>
          </h2>
        </motion.div>

        {/* Cards */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "28px" }}>
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              style={{
                background: "#161616",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: "4px",
                overflow: "hidden",
                transition: "border-color 0.3s, transform 0.2s",
              }}
              whileHover={{ y: -6 }}
            >
              {/* Service image */}
              <div style={{ position: "relative", height: "200px", overflow: "hidden" }}>
                <img
                  src={s.img}
                  alt={s.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.5s" }}
                />
                <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom, transparent 40%, rgba(22,22,22,1) 100%)" }} />
                <div style={{ position: "absolute", top: "16px", left: "16px", color: "#E8212A" }}>
                  {s.icon}
                </div>
              </div>

              <div style={{ padding: "24px" }}>
                <p style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "11px", color: "#E8212A", letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 700, marginBottom: "6px" }}>
                  {s.title}
                </p>
                <h3 style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "24px", fontWeight: 700, color: "#fff", marginBottom: "12px" }}>
                  {s.titleTh}
                </h3>
                <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "14px", color: "rgba(255,255,255,0.65)", lineHeight: 1.7, marginBottom: "20px" }}>
                  {s.desc}
                </p>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {s.tags.map((t) => (
                    <span
                      key={t}
                      style={{
                        padding: "4px 10px",
                        background: "rgba(232,33,42,0.12)",
                        border: "1px solid rgba(232,33,42,0.3)",
                        color: "#E8212A",
                        fontSize: "11px",
                        fontFamily: "Rajdhani, sans-serif",
                        fontWeight: 600,
                        letterSpacing: "0.05em",
                        borderRadius: "2px",
                      }}
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* @section: products */
function Products() {
  const dwdModels = [
    {
      id: "dds-plus",
      name: "DD-S+",
      type: "COILOVER STREET+",
      typeTh: "สายถนน",
      badge: "Most Affordable",
      badgeColor: "#2563eb",
      comfort: 60,
      handling: 40,
      desc: "ราคาเข้าถึงง่าย ปรับ Rebound 32 ระดับ ปรับความสูงได้โดยไม่กระทบสปริง เหมาะสำหรับใช้งานบนถนนทั่วไป",
      features: ["32-Clicks Rebound", "Height Adjustable", "Anti-Rust Coating", "Mono Tube"],
      img: IMAGES.ddSPlus,
      productImg: IMAGES.ddSPlus,
    },
    {
      id: "dd-rs",
      name: "DD-RS",
      type: "COILOVER PRO",
      typeTh: "Street & Track",
      badge: "2-WAY",
      badgeColor: "#7c3aed",
      comfort: 80,
      handling: 20,
      desc: "Long-stroke design รองรับทั้งถนนและสนามแข่ง มีถังไนโตรเจนแยกภายนอก ปรับ Compression & Rebound อิสระ",
      features: ["2-Way Adjustable", "External Nitrogen", "Long Stroke", "Aluminum Top Mount"],
      img: IMAGES.ddRS,
      productImg: IMAGES.ddRS,
    },
    {
      id: "dd-r-plus",
      name: "DD-R+",
      type: "COILOVER RACING+",
      typeTh: "สนามแข่ง",
      badge: "TRACK",
      badgeColor: "#dc2626",
      comfort: 20,
      handling: 80,
      desc: "Born for the track — Inverted Mono Tube Design ลูกสูบขนาดใหญ่ แรงหน่วงสูง ลดความร้อนสะสม",
      features: ["Inverted Mono Tube", "Large Piston", "Heat Fade Resist", "32-Clicks"],
      img: IMAGES.ddRPlus,
      productImg: IMAGES.ddRPlus,
    },
    {
      id: "dd-a",
      name: "DD-A",
      type: "COILOVER AIR",
      typeTh: "ระบบถุงลม",
      badge: "LOWER",
      badgeColor: "#0891b2",
      comfort: 50,
      handling: 50,
      desc: "ถังลม Seamless Aluminum + Compressor เงียบ + Auto Drain จดจำระดับความสูงได้ 5 ระดับ ปรับลดความสูงด้วยสัมผัสเดียว",
      features: ["5-Level Memory", "Silent Compressor", "Auto Drainage", "One-Touch Lower"],
      img: IMAGES.ddA,
      productImg: IMAGES.ddA,
    },
    {
      id: "dd-5",
      name: "DD-5",
      type: "OFFROAD OIL",
      typeTh: "ออฟโรด น้ำมัน",
      badge: "OFFROAD",
      badgeColor: "#16a34a",
      comfort: 70,
      handling: 30,
      desc: "ยกรถสูง 2–2.5 นิ้ว Preset Damping เข้ากับสปริงได้สมบูรณ์แบบ ดูดซับแรงกระแทกได้ดีทั้งบนถนนและออฟโรด",
      features: ["Lift 2–2.5 inch", "Twin Tube Design", "Preset Damping", "Heavy Duty"],
      img: IMAGES.dd5,
      productImg: IMAGES.dd5,
    },
    {
      id: "dd-7",
      name: "DD-7",
      type: "PRO OFFROAD NITROGEN",
      typeTh: "ออฟโรด ไนโตรเจน",
      badge: "PRO",
      badgeColor: "#b45309",
      comfort: 50,
      handling: 50,
      desc: "ยกรถสูง 2.5 นิ้ว ถังไนโตรเจนภายนอก ช่วงชักยาว ปรับ Damping ได้กว้าง รองรับทุกสภาพภูมิประเทศ",
      features: ["Lift 2.5 inch", "External N₂ Tank", "Adjustable Damping", "All Terrain"],
      img: IMAGES.dd7,
      productImg: IMAGES.dd7,
    },
  ];

  return (
    <section id="products" style={{ background: "#0D0D0D", padding: "100px 0" }}>
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: "center", marginBottom: "20px" }}
        >
          <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "13px", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, marginBottom: "16px" }}>
            สินค้าของเรา
          </p>
          <h2 style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(32px, 5vw, 56px)", fontWeight: 700, color: "#FFFFFF", lineHeight: 1.1 }}>
            DWD <span style={{ color: "#E8212A" }}>COILOVER</span> SERIES
          </h2>
        </motion.div>

        {/* Brand badge */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ display: "flex", justifyContent: "center", marginBottom: "60px" }}
        >
          <div style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "10px",
            padding: "8px 20px",
            background: "rgba(232,33,42,0.1)",
            border: "1px solid rgba(232,33,42,0.35)",
            borderRadius: "2px",
          }}>
            <div style={{ width: "8px", height: "8px", background: "#E8212A", borderRadius: "50%" }} />
            <span style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "13px", fontWeight: 700, color: "rgba(255,255,255,0.8)", letterSpacing: "0.15em", textTransform: "uppercase" }}>
              Official DWD Thailand Dealer — ตัวแทนจำหน่ายอย่างเป็นทางการ
            </span>
          </div>
        </motion.div>

        {/* 6 Model Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(290px, 1fr))", gap: "24px" }}>
          {dwdModels.map((m, i) => (
            <motion.div
              key={m.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              whileHover={{ y: -5 }}
              style={{
                background: "#161616",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: "4px",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Top color bar */}
              <div style={{ height: "4px", background: m.badgeColor }} />
              {/* Product Image */}
              <div style={{ background: "#0a0a0a", padding: "20px", display: "flex", justifyContent: "center", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                <img src={m.img} alt={m.name} style={{ height: "160px", objectFit: "contain", maxWidth: "100%" }} />
              </div>

              <div style={{ padding: "24px", flex: 1, display: "flex", flexDirection: "column" }}>
                {/* Header row */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "16px" }}>
                  <div>
                    <p style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "11px", color: "rgba(255,255,255,0.4)", letterSpacing: "0.2em", textTransform: "uppercase", marginBottom: "4px" }}>
                      DWD Thailand
                    </p>
                    <h3 style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "36px", fontWeight: 700, color: "#fff", lineHeight: 1, marginBottom: "2px" }}>
                      {m.name}
                    </h3>
                    <p style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "11px", color: m.badgeColor, fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase" }}>
                      {m.type}
                    </p>
                  </div>
                  <div style={{
                    padding: "4px 10px",
                    background: m.badgeColor,
                    color: "#fff",
                    fontFamily: "Rajdhani, sans-serif",
                    fontWeight: 700,
                    fontSize: "11px",
                    letterSpacing: "0.1em",
                    borderRadius: "2px",
                    flexShrink: 0,
                  }}>
                    {m.badge}
                  </div>
                </div>

                {/* Comfort / Handling bars */}
                <div style={{ marginBottom: "16px", display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                      <span style={{ fontFamily: "Sarabun, sans-serif", fontSize: "11px", color: "rgba(255,255,255,0.5)" }}>Comfort</span>
                      <span style={{ fontFamily: "JetBrains Mono, monospace", fontSize: "11px", color: "rgba(255,255,255,0.5)" }}>{m.comfort}%</span>
                    </div>
                    <div style={{ height: "4px", background: "rgba(255,255,255,0.1)", borderRadius: "2px" }}>
                      <div style={{ height: "100%", width: `${m.comfort}%`, background: "#4ade80", borderRadius: "2px", transition: "width 1s" }} />
                    </div>
                  </div>
                  <div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "4px" }}>
                      <span style={{ fontFamily: "Sarabun, sans-serif", fontSize: "11px", color: "rgba(255,255,255,0.5)" }}>Handling</span>
                      <span style={{ fontFamily: "JetBrains Mono, monospace", fontSize: "11px", color: "rgba(255,255,255,0.5)" }}>{m.handling}%</span>
                    </div>
                    <div style={{ height: "4px", background: "rgba(255,255,255,0.1)", borderRadius: "2px" }}>
                      <div style={{ height: "100%", width: `${m.handling}%`, background: "#E8212A", borderRadius: "2px", transition: "width 1s" }} />
                    </div>
                  </div>
                </div>

                <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "13px", color: "rgba(255,255,255,0.6)", lineHeight: 1.7, marginBottom: "16px", flex: 1 }}>
                  {m.desc}
                </p>

                {/* Feature tags */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", marginBottom: "20px" }}>
                  {m.features.map((f) => (
                    <span key={f} style={{
                      padding: "3px 8px",
                      background: "rgba(255,255,255,0.05)",
                      border: "1px solid rgba(255,255,255,0.1)",
                      color: "rgba(255,255,255,0.6)",
                      fontSize: "10px",
                      fontFamily: "Rajdhani, sans-serif",
                      fontWeight: 600,
                      letterSpacing: "0.04em",
                      borderRadius: "2px",
                    }}>
                      {f}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <div style={{ display: "flex", gap: "8px" }}>
                  <a
                    href="https://lin.ee/usuFQKq"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      flex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "6px",
                      padding: "10px",
                      background: "#06C755",
                      color: "#fff",
                      textDecoration: "none",
                      fontFamily: "Rajdhani, sans-serif",
                      fontWeight: 700,
                      fontSize: "13px",
                      letterSpacing: "0.06em",
                      borderRadius: "2px",
                    }}
                  >
                    <SiLine size={13} /> สอบถาม LINE
                  </a>
                  <a
                    href="https://www.facebook.com/EnzoPerformanteStore/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "10px 12px",
                      background: "rgba(24,119,242,0.15)",
                      border: "1px solid rgba(24,119,242,0.4)",
                      color: "#60a5fa",
                      textDecoration: "none",
                      borderRadius: "2px",
                    }}
                  >
                    <SiFacebook size={15} />
                  </a>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: "center", marginTop: "56px" }}
        >
          <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "15px", color: "rgba(255,255,255,0.5)", marginBottom: "20px" }}>
            📲 จองคิวหรือสอบถามเพิ่มเติม ทักแชทได้เลย!
          </p>
          <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
            <a
              href="https://lin.ee/usuFQKq"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "13px 28px",
                background: "#06C755",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "15px",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                borderRadius: "2px",
              }}
            >
              <SiLine size={16} /> Add LINE @638lkjit
            </a>
            <a
              href="tel:0869978800"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                padding: "13px 28px",
                background: "transparent",
                border: "2px solid rgba(255,255,255,0.25)",
                color: "#fff",
                textDecoration: "none",
                fontFamily: "Rajdhani, sans-serif",
                fontWeight: 700,
                fontSize: "15px",
                letterSpacing: "0.08em",
                borderRadius: "2px",
              }}
            >
              <Phone size={16} /> 086-997-8800
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

/* @section: detailing */
function DetailingSection() {
  const detailing = [
    {
      id: "hyper-wax", name: "HYPER WAX", sub: "Liquid Ceramic Coating 250ml",
      badge: "Best Seller",
      feature: "สูตร Liquid Ceramic ผสม SiO₂ + Multi-Complex Wax ใช้ง่ายแค่ 'ฉีดแล้วเช็ด'",
      advantage: "สร้างชั้น Ceramic Film ปกป้องสีรถจากฝุ่น UV และมลภาวะ ให้ความเงาระดับ Showroom",
      benefit: "รถสวยเงาได้ใน 3 นาที ล้างรถง่ายขึ้น ฝุ่นและน้ำไม่เกาะสีรถ",
    },
    {
      id: "hyper-gel", name: "HYPER GEL", sub: "Tyre & Rubber Restoration 250ml",
      badge: "UV Shield",
      feature: "เจลสูตรพิเศษ Hydrophobic ไม่เหนียว สำหรับยางรถยนต์และชิ้นส่วนสีดำ",
      advantage: "ฟื้นฟูความเงายางและพลาสติกสีดำทันที สร้างชั้นป้องกัน UV ความชื้น และโอโซน",
      benefit: "ยางและชิ้นส่วนดูใหม่เหมือนเพิ่งซื้อรถ ป้องกันความเสื่อมสภาพระยะยาว",
    },
    {
      id: "leather", name: "LEATHER EMULSION", sub: "Intensive Conditioner 250ml",
      badge: "Premium Care",
      feature: "สูตร Intensive Emulsion ผสม Multi-Complex Wax พิเศษ ฉีดแล้วเช็ด ง่ายสุดๆ",
      advantage: "บำรุงและฟื้นฟูหนังรถอย่างล้ำลึก แทรกซึมเข้าสู่เนื้อหนัง ป้องกันการแตกแห้ง",
      benefit: "หนังนุ่ม เรียบลื่น ดูใหม่ ไม่แตกแห้ง กลิ่นหนังใหม่ รักษามูลค่ารถ",
    },
    {
      id: "rain-shield", name: "RAIN SHIELD", sub: "Water Repellent Coating 100ml",
      badge: "Safety First",
      feature: "สูตร Hydrophobic Coating เข้มข้น ใช้ได้กับกระจกทุกชนิด ทนทานยาวนาน",
      advantage: "น้ำเกาะเป็นหยดกลมแล้วกลิ้งออกเองอย่างรวดเร็ว มองเห็นถนนชัดแม้ฝนตกหนัก",
      benefit: "ขับรถปลอดภัยกว่าในวันฝนตก ยืดอายุใบปัดน้ำฝน ใช้ครั้งเดียวทนนาน",
    },
  ];
  const BOTTLES = "https://skyagent-artifacts.skywork.ai/image/317c2af3-f3bf-4d1a-aeff-3678ee16544c/9217f81c-60af-4179-9254-1ea5c0502d35/prod_agent_317c2af3-f3bf-4d1a-aeff-3678ee16544c/enzo_detailing_series_ultrawide_2.png";

  return (
    <section id="detailing" style={{ background: "#0D0D0D", padding: "100px 0" }}>
      <div className="container mx-auto px-4">
        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, letterSpacing: "0.2em", fontSize: "13px", textTransform: "uppercase", marginBottom: "8px" }}>ENZO CAR DETAILING</p>
          <h2 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(30px,4vw,48px)", fontWeight: 800, textTransform: "uppercase", marginBottom: "12px" }}>DETAILING COLLECTION</h2>
          <p style={{ color: "#aaa", fontSize: "15px", fontFamily: "Sarabun, sans-serif", maxWidth: "520px", margin: "0 auto" }}>ผลิตภัณฑ์ดูแลรถยนต์คุณภาพพรีเมียม ปกป้องและเพิ่มความงามให้รถของคุณ</p>
        </div>
        {/* Hero bottles image */}
        <div style={{ background: "#000", border: "1px solid rgba(255,255,255,0.06)", borderRadius: "4px", marginBottom: "48px", padding: "40px 20px", display: "flex", justifyContent: "center" }}>
          <img src={BOTTLES} alt="ENZO Detailing Products" style={{ width: "100%", maxWidth: "100%", maxHeight: "480px", objectFit: "contain" }} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: "24px" }}>
          {detailing.map(p => (
            <div key={p.id} style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "4px", overflow: "hidden", transition: "border-color 0.2s, transform 0.2s" }}
              onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(232,33,42,0.5)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(-3px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(255,255,255,0.07)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)"; }}>
              <div style={{ height: "3px", background: "#E8212A" }} />
              <div style={{ padding: "20px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                  <h3 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "18px", fontWeight: 800, margin: 0 }}>{p.name}</h3>
                  <span style={{ background: "rgba(232,33,42,0.15)", border: "1px solid rgba(232,33,42,0.3)", color: "#E8212A", padding: "2px 8px", borderRadius: "2px", fontSize: "10px", fontWeight: 700, fontFamily: "Rajdhani, sans-serif", whiteSpace: "nowrap" }}>{p.badge}</span>
                </div>
                <p style={{ color: "#888", fontFamily: "Rajdhani, sans-serif", fontSize: "11px", letterSpacing: "0.08em", marginBottom: "12px" }}>{p.sub}</p>
                {[{ label: "Feature", color: "#E8212A", text: p.feature }, { label: "Advantage", color: "#f59e0b", text: p.advantage }, { label: "Benefit", color: "#4ade80", text: p.benefit }].map(r => (
                  <div key={r.label} style={{ marginBottom: "8px", paddingLeft: "10px", borderLeft: `2px solid ${r.color}` }}>
                    <span style={{ color: r.color, fontFamily: "Rajdhani, sans-serif", fontSize: "10px", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", display: "block", marginBottom: "2px" }}>{r.label}</span>
                    <p style={{ color: "#ccc", fontSize: "12px", fontFamily: "Sarabun, sans-serif", lineHeight: 1.5, margin: 0 }}>{r.text}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <a href="/#/products#detailing" style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "12px 28px", background: "#E8212A", color: "#fff", textDecoration: "none", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, fontSize: "14px", letterSpacing: "0.05em", textTransform: "uppercase", borderRadius: "2px" }}>
            สอบถามสินค้า ENZO Detailing
          </a>
        </div>
      </div>
    </section>
  );
}

/* @section: motve */
function MotveSection() {
  const motve = [
    { id: "gs6", name: "GS6", type: "6-Piston Street", img: "https://static-us-img.skywork.ai/prod/nexus/1781619877/cropped_image_0_1781619877112854842.jpg", desc: "คาลิปเปอร์ 6 ลูกสูบสำหรับใช้งานบนถนนและ Track Day สมรรถนะสูง", specs: ["2×31.8 / 2×31.8 / 2×41.3mm", "พื้นที่ลูกสูบ 58cm²", "จานเบรก φ380–400mm"] },
    { id: "gf6", name: "GF6", type: "6-Piston Offroad", img: "https://static-us-img.skywork.ai/prod/nexus/1781619876/cropped_image_1_1781619876918596078.jpg", desc: "คาลิปเปอร์ 6 ลูกสูบออกแบบพิเศษสำหรับรถออฟโรด Forged Aluminum และ Cast Iron", specs: ["2×36 / 2×38 / 2×41.3mm", "พื้นที่ลูกสูบ 69cm²", "จานเบรก φ335–355mm"] },
    { id: "r60", name: "R60", type: "6-Piston Mono-Block", img: "https://static-us-img.skywork.ai/prod/nexus/1781619876/cropped_image_1_1781619876715520058.jpg", desc: "Forged Mono-Block ตัวเดียว แข็งแกร่งสูงสุด เหมาะสำหรับ Track Day", specs: ["2×27 / 2×31.8 / 2×38mm", "พื้นที่ลูกสูบ 50cm²", "จานเบรก φ355–378mm"] },
    { id: "mt6", name: "MT6", type: "6-Piston Performance", img: "https://static-us-img.skywork.ai/prod/nexus/1781619875/cropped_image_1_1781619875350709927.jpg", desc: "คาลิปเปอร์ 6 ลูกสูบสมรรถนะสูง น้ำหนักเบา เหมาะสำหรับ Street และ Track", specs: ["2×27 / 2×31.8 / 2×38.1mm", "พื้นที่ลูกสูบ 50cm²", "น้ำหนัก 3.5kg"] },
  ];
  return (
    <section id="motve" style={{ background: "#111", padding: "100px 0" }}>
      <div className="container mx-auto px-4">
        <div style={{ textAlign: "center", marginBottom: "56px" }}>
          <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, letterSpacing: "0.2em", fontSize: "13px", textTransform: "uppercase", marginBottom: "8px" }}>MOTVE OFFICIAL DISTRIBUTOR</p>
          <h2 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "clamp(30px,4vw,48px)", fontWeight: 800, textTransform: "uppercase", marginBottom: "12px" }}>MOTVE BRAKE SYSTEMS</h2>
          <p style={{ color: "#aaa", fontSize: "15px", fontFamily: "Sarabun, sans-serif", maxWidth: "520px", margin: "0 auto" }}>ระบบเบรกสมรรถนะสูง คาลิปเปอร์ 6 ลูกสูบ รับประกันโครงสร้าง 5 ปี</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: "24px" }}>
          {motve.map(m => (
            <div key={m.id} style={{ background: "#161616", border: "1px solid rgba(255,255,255,0.07)", borderRadius: "4px", overflow: "hidden", transition: "border-color 0.2s, transform 0.2s" }}
              onMouseEnter={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(232,33,42,0.5)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(-3px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(255,255,255,0.07)"; (e.currentTarget as HTMLDivElement).style.transform = "translateY(0)"; }}>
              <div style={{ height: "3px", background: "#E8212A" }} />
              <div style={{ background: "#0a0a0a", padding: "24px 20px", display: "flex", justifyContent: "center", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
                <img src={m.img} alt={m.name} style={{ height: "200px", objectFit: "contain", maxWidth: "100%" }} />
              </div>
              <div style={{ padding: "20px" }}>
                <span style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "12px", fontWeight: 700, letterSpacing: "0.1em" }}>MOTVE</span>
                <h3 style={{ color: "#fff", fontFamily: "Rajdhani, sans-serif", fontSize: "28px", fontWeight: 800, lineHeight: 1, margin: "2px 0 2px" }}>{m.name}</h3>
                <p style={{ color: "#888", fontFamily: "Rajdhani, sans-serif", fontSize: "12px", letterSpacing: "0.08em", marginBottom: "8px" }}>{m.type}</p>
                <p style={{ color: "#bbb", fontSize: "13px", fontFamily: "Sarabun, sans-serif", lineHeight: 1.6, marginBottom: "10px" }}>{m.desc}</p>
                {m.specs.map(s => (
                  <div key={s} style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                    <span style={{ width: "4px", height: "4px", borderRadius: "50%", background: "#E8212A", flexShrink: 0 }} />
                    <span style={{ color: "#ccc", fontSize: "12px", fontFamily: "Sarabun, sans-serif" }}>{s}</span>
                  </div>
                ))}
                <div style={{ display: "flex", alignItems: "center", gap: "6px", marginTop: "6px" }}>
                  <span style={{ width: "4px", height: "4px", borderRadius: "50%", background: "#4ade80", flexShrink: 0 }} />
                  <span style={{ color: "#4ade80", fontSize: "12px", fontFamily: "Sarabun, sans-serif", fontWeight: 600 }}>รับประกันโครงสร้าง 5 ปี</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <a href="/#/products#motve" style={{ display: "inline-flex", alignItems: "center", gap: "8px", padding: "12px 28px", background: "#E8212A", color: "#fff", textDecoration: "none", fontFamily: "Rajdhani, sans-serif", fontWeight: 700, fontSize: "14px", letterSpacing: "0.05em", textTransform: "uppercase", borderRadius: "2px" }}>
            สอบถามราคา MOTVE Brake
          </a>
        </div>
      </div>
    </section>
  );
}

/* @section: gallery */
function Gallery() {
  const photos = [
    { src: IMAGES.hero, alt: "ENZO Store Front", size: "large" },
    { src: IMAGES.blackEV, alt: "Black EV at ENZO", size: "medium" },
    { src: IMAGES.whiteEV, alt: "White EV at ENZO", size: "medium" },
    { src: IMAGES.workshopAction, alt: "Workshop in action", size: "medium" },
    { src: IMAGES.coilover, alt: "DWD Coilover", size: "medium" },
    { src: IMAGES.sign3D, alt: "ENZO 3D Sign", size: "medium" },
    { src: IMAGES.sticker, alt: "ENZO Sticker", size: "medium" },
    { src: IMAGES.workshop, alt: "Workshop interior", size: "large" },
  ];

  return (
    <section id="gallery" style={{ background: "#111", padding: "100px 0" }}>
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: "center", marginBottom: "64px" }}
        >
          <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "13px", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, marginBottom: "16px" }}>
            ภาพผลงาน
          </p>
          <h2
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(32px, 5vw, 56px)",
              fontWeight: 700,
              color: "#FFFFFF",
              lineHeight: 1.1,
            }}
          >
            OUR <span style={{ color: "#E8212A" }}>GALLERY</span>
          </h2>
        </motion.div>

        {/* Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "12px" }}>
          {photos.map((ph, i) => (
            <motion.div
              key={ph.src}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              style={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "3px",
                aspectRatio: ph.size === "large" ? "16/9" : "4/3",
                gridColumn: ph.size === "large" ? "span 2" : "span 1",
                cursor: "pointer",
              }}
              whileHover={{ scale: 1.02 }}
            >
              <img
                src={ph.src}
                alt={ph.alt}
                style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.5s" }}
              />
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "linear-gradient(to top, rgba(13,13,13,0.7) 0%, transparent 60%)",
                  opacity: 0,
                  transition: "opacity 0.3s",
                }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLDivElement).style.opacity = "1"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLDivElement).style.opacity = "0"; }}
              />
              <div
                style={{
                  position: "absolute",
                  bottom: "12px",
                  left: "12px",
                  color: "#fff",
                  fontFamily: "Rajdhani, sans-serif",
                  fontSize: "13px",
                  fontWeight: 600,
                  letterSpacing: "0.05em",
                  pointerEvents: "none",
                }}
              >
                {ph.alt}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* @section: contact */
function Contact() {
  return (
    <section id="contact" style={{ background: "#0D0D0D", padding: "100px 0 0" }}>
      <div className="container mx-auto px-4">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          style={{ textAlign: "center", marginBottom: "64px" }}
        >
          <p style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "13px", letterSpacing: "0.3em", textTransform: "uppercase", fontWeight: 700, marginBottom: "16px" }}>
            ติดต่อ & หาเราให้เจอ
          </p>
          <h2
            style={{
              fontFamily: "Rajdhani, sans-serif",
              fontSize: "clamp(32px, 5vw, 56px)",
              fontWeight: 700,
              color: "#FFFFFF",
              lineHeight: 1.1,
            }}
          >
            CONTACT <span style={{ color: "#E8212A" }}>US</span>
          </h2>
        </motion.div>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "48px", marginBottom: "60px" }}>
          {/* Info */}
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "28px" }}>

              {/* Hours */}
              <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                <div style={{ width: "44px", height: "44px", background: "rgba(232,33,42,0.12)", border: "1px solid rgba(232,33,42,0.3)", borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Clock size={20} color="#E8212A" />
                </div>
                <div>
                  <p style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "4px" }}>เวลาทำการ</p>
                  <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "15px", color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>
                    9:00 - 18:00<br />
                    เวลาทำการ · จันทร์ – อาทิตย์
                  </p>
                </div>
              </div>

              {/* Location */}
              <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                <div style={{ width: "44px", height: "44px", background: "rgba(232,33,42,0.12)", border: "1px solid rgba(232,33,42,0.3)", borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <MapPin size={20} color="#E8212A" />
                </div>
                <div>
                  <p style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "4px" }}>ที่อยู่</p>
                  <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "15px", color: "rgba(255,255,255,0.7)", lineHeight: 1.7 }}>
                    DWD THAILAND × ENZO Performante Store<br />
                    <strong style={{ color: "rgba(255,255,255,0.9)" }}>สาขาประชาอุทิศ</strong>
                  </p>
                  <a
                    href="https://maps.app.goo.gl/xJdCGjA66nCEA8v97"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#E8212A", fontFamily: "Rajdhani, sans-serif", fontSize: "13px", fontWeight: 700, letterSpacing: "0.08em", textDecoration: "none", textTransform: "uppercase" }}
                  >
                    ดูบน Google Maps →
                  </a>
                </div>
              </div>

              {/* Phone */}
              <div style={{ display: "flex", gap: "16px", alignItems: "flex-start" }}>
                <div style={{ width: "44px", height: "44px", background: "rgba(232,33,42,0.12)", border: "1px solid rgba(232,33,42,0.3)", borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <Phone size={20} color="#E8212A" />
                </div>
                <div style={{ width: "100%" }}>
                  <p style={{ fontFamily: "Rajdhani, sans-serif", fontSize: "14px", fontWeight: 700, color: "#fff", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "8px" }}>ช่องทางติดต่อ</p>

                  {/* Phone number */}
                  <a
                    href="tel:0869978800"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      padding: "10px 16px",
                      background: "rgba(232,33,42,0.1)",
                      border: "1px solid rgba(232,33,42,0.3)",
                      color: "#fff",
                      textDecoration: "none",
                      borderRadius: "3px",
                      fontFamily: "Rajdhani, sans-serif",
                      fontWeight: 700,
                      fontSize: "18px",
                      letterSpacing: "0.05em",
                      marginBottom: "10px",
                    }}
                  >
                    <Phone size={16} color="#E8212A" /> 086-997-8800
                  </a>

                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    <a
                      href="https://lin.ee/usuFQKq"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 20px",
                        background: "#06C755",
                        color: "#fff",
                        textDecoration: "none",
                        borderRadius: "3px",
                        fontFamily: "Rajdhani, sans-serif",
                        fontWeight: 700,
                        fontSize: "14px",
                        letterSpacing: "0.05em",
                      }}
                    >
                      <SiLine size={16} /> LINE @638lkjit
                    </a>
                    <a
                      href="https://www.facebook.com/EnzoPerformanteStore/"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 20px",
                        background: "#1877F2",
                        color: "#fff",
                        textDecoration: "none",
                        borderRadius: "3px",
                        fontFamily: "Rajdhani, sans-serif",
                        fontWeight: 700,
                        fontSize: "14px",
                        letterSpacing: "0.05em",
                      }}
                    >
                      <SiFacebook size={16} /> Facebook
                    </a>
                  </div>

                  {/* QR Code Card */}
                  <a
                    href="https://lin.ee/usuFQKq"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "16px",
                      marginTop: "16px",
                      padding: "16px",
                      background: "#fff",
                      borderRadius: "8px",
                      textDecoration: "none",
                      border: "3px solid #06C755",
                      maxWidth: "260px",
                    }}
                  >
                    <img
                      src={IMAGES.lineQR}
                      alt="LINE QR Code @638lkjit"
                      style={{ width: "90px", height: "90px", objectFit: "contain", flexShrink: 0 }}
                    />
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "4px" }}>
                        <SiLine size={18} color="#06C755" />
                        <span style={{ fontFamily: "Rajdhani, sans-serif", fontWeight: 700, fontSize: "16px", color: "#06C755", letterSpacing: "0.05em" }}>
                          ADD LINE
                        </span>
                      </div>
                      <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "13px", color: "#222", lineHeight: 1.5, margin: 0 }}>
                        สแกน QR Code<br />
                        เพื่อเพิ่มเพื่อน<br />
                        <strong>@638lkjit</strong>
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }}>
            <div style={{ borderRadius: "4px", overflow: "hidden", border: "1px solid rgba(232,33,42,0.3)", height: "360px" }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.0!2d100.56!3d13.68!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29f7b9c5c4d3b%3A0x0!2zRFdEIFRIQUlMQU5EIOC4quC4seC4quC4reC4teC5gOC4h-C5geC4peC4sOC4pyDguYDguKfguIjguJXguJTguKPguKfguIbguLLguKHguJfguLLguJk!5e0!3m2!1sth!2sth!4v1700000000000!5m2!1sth!2sth"
                width="100%"
                height="100%"
                style={{ border: 0, display: "block" }}
                allowFullScreen
                loading="lazy"
                title="DWD Thailand x ENZO Performante Store สาขาประชาอุทิศ"
              />
            </div>
            <div style={{ marginTop: "12px", textAlign: "center" }}>
              <a
                href="https://maps.app.goo.gl/xJdCGjA66nCEA8v97"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "Sarabun, sans-serif",
                  fontSize: "13px",
                  textDecoration: "none",
                  transition: "color 0.2s",
                }}
              >
                <MapPin size={14} />
                เปิดใน Google Maps — สาขาประชาอุทิศ
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ borderTop: "1px solid rgba(255,255,255,0.07)", background: "#080808", padding: "40px 0" }}>
        <div className="container mx-auto px-4">
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "20px", textAlign: "center" }}>
            <img src={IMAGES.logo} alt="ENZO Performante Store" style={{ height: "48px", objectFit: "contain" }} />
            <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "14px", color: "rgba(255,255,255,0.4)", maxWidth: "400px", lineHeight: 1.6 }}>
              DWD Thailand x ENZO Performante Store — The Ultimate Destination for Performance Upgrades
            </p>
            <div style={{ display: "flex", gap: "20px" }}>
              <a href="https://www.facebook.com/EnzoPerformanteStore/" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.4)", transition: "color 0.2s" }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#E8212A"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.4)"; }}
              >
                <SiFacebook size={20} />
              </a>
              <a href="https://lin.ee/usuFQKq" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.4)", transition: "color 0.2s" }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#06C755"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.4)"; }}
              >
                <SiLine size={20} />
              </a>
              <a href="https://www.tiktok.com/@iracealot" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.4)", transition: "color 0.2s" }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#fff"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.4)"; }}
              >
                <SiTiktok size={20} />
              </a>
              <a href="https://maps.app.goo.gl/xJdCGjA66nCEA8v97" target="_blank" rel="noopener noreferrer" style={{ color: "rgba(255,255,255,0.4)", transition: "color 0.2s" }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "#E8212A"; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = "rgba(255,255,255,0.4)"; }}
              >
                <MapPin size={20} />
              </a>
            </div>
            <p style={{ fontFamily: "Sarabun, sans-serif", fontSize: "12px", color: "rgba(255,255,255,0.25)" }}>
              © 2025 ENZO Performante Store. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </section>
  );
}

/* @section: main */
const Index = () => {
  return (
    <div style={{ background: "#0D0D0D", minHeight: "100vh" }}>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Products />
      <DetailingSection />
      <MotveSection />
      <Gallery />
      <Contact />
    </div>
  );
};

export default Index;
